// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__drGV7"};